<template>
  <div>
    <h5 class="headline">{{ $t("contract.confidentialInfo.headline") }}</h5>
    <p>{{ $t("contract.confidentialInfo.paragraphOne") }}</p>
    <p>{{ $t("contract.confidentialInfo.paragraphTwo") }}</p>
    <p class="user-output">
      {{ $t("contract.confidentialInfo.paragraphThree", { description }) }}
    </p>
    <p>{{ $t("contract.confidentialInfo.paragraphFour") }}</p>
    <p>{{ $t("contract.confidentialInfo.paragraphFive") }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    agreement() {
      return this.$store.state.contract.agreement;
    },
    description() {
      return this.agreement.description !== ""
        ? this.agreement.description
        : this.$t("contract.confidentialInfo.placeholder.description");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/ConfidentialInfo.vue